<template>
  <div>
    <template v-for="locale in ['fr', 'en']">
      <v-btn :key="locale" v-if="$i18n.locale !== locale" text color="primary" @click="changeLocaleTo(locale)">{{ $t(`locales.${locale}`) }}</v-btn>
    </template>
  </div>
</template>

<script>
import ChangeLocale from "@/mixins/ChangeLocale"

export default {
  mixins: [ChangeLocale],
  mounted() {
    this.changeLocaleTo(this.$route.query.lang || "fr")
  }
}
</script>

<style>
</style>